/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Loading } from '@/components';
import api from '@/services/api';
import { AxiosError } from 'axios';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ValidationReport } from '@/model/ValidationReport';
// import EventMainReport from '@/model/EventMainReport';
import { ValidationFilterReport } from '@/model/ValidationFilterReport';
import { ValidationCourtesyExportReport } from '@/model/ValidationCourtesyExportReport';
import { ReportControllerProps } from '../../types';
import { ValidationContent } from './ui';

interface ValidationProps {
  reportController: ReportControllerProps;
  // eventChild?: EventMainReport;
  generatePDF: () => void;
}

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

export const Validation: React.FC<ValidationProps> = ({
  reportController,
  generatePDF,
  // eventChild,
}) => {
  const [state, setState] = useState<States>(States.default);
  const [validation, setValidation] = useState<ValidationReport>();
  const [startDate, setStartDate] = useState<string>();
  const [reload, setReload] = useState<boolean>(false);

  const { eventId, singleEvent } = reportController;

  const handleGetValidation = async (): Promise<void> => {
    if (validation === undefined || reload === true) {
      try {
        setState(States.loading);
        const payload: ValidationFilterReport = {};
        if (startDate && startDate !== 'select') {
          payload.startDate = startDate;
        }
        const { data } = await api.post<ValidationReport>(
          `event/report/${eventId}/validation?singleEvent=${singleEvent}`,
          payload,
        );
        if (data) {
          setValidation(data);
        }
      } catch (error) {
        const err = error as AxiosError;
        toast.error(err.message);
      } finally {
        setState(States.default);
        setReload(false);
      }
    }
  };

  const handleOnChangeSelectDate = async (value: string | undefined): Promise<void> => {
    if (value) {
      setStartDate(value);
      setReload(true);
    }
  };

  const handleOnExportCourtesy = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<ValidationCourtesyExportReport>(
        `event/report/${eventId}/validation/courtesy/export?singleEvent=${singleEvent}`,
      );
      const newLink = document.createElement('a');
      newLink.href = `data:application/octet-stream;base64,${data.base64}`;
      newLink.download = 'validacao_cortesia.csv';
      newLink.click();
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    if (reload) {
      handleGetValidation();
    }
  }, [reload]);

  useEffect(() => {
    handleGetValidation();
  }, []);

  return (
    <>
      <Loading isVisible={state === 'loading'} />
      <ValidationContent
        validation={validation}
        startDate={startDate}
        onChangeSelectDate={handleOnChangeSelectDate}
        generatePDF={generatePDF}
        exportCourtesy={handleOnExportCourtesy}
        // eventChild={eventChild}
      />
    </>
  );
};
